const CryptoJS = require("crypto-js");

function encryptStringHash(textString) {
    return CryptoJS.SHA1(textString).toString()
}

function encryptString(textString) {
    let valor = CryptoJS.AES.encrypt(textString, process.env.REACT_APP_KEY_ENCRYPT).toString()
    return valor
}

function decryptString(textEncrypt) {
    const decrypted = CryptoJS.AES.decrypt(textEncrypt, process.env.REACT_APP_KEY_ENCRYPT)
    if (decrypted) {
        return decrypted.toString(CryptoJS.enc.Utf8);
    }
    return 'error_al_recuperar_el_token'
}


export const account = {

    saveToken: function(token) {
        window.localStorage.setItem(encryptStringHash("token"), encryptString(token))
    },

    getToken: function() {
        let token = window.localStorage.getItem(encryptStringHash("token"))
        if (token)
            return decryptString(token)
        else
            return ''
    },

    removeToken: function() {
        try{
            window.localStorage.removeItem(encryptStringHash("token"))        
        }catch(error){
        }
    },

    removeUltEmbarque: function() {
        try{

            localStorage.removeItem("LastEmbarque")      
        }catch(error){
        }
    },



    saveDatosUsuario: function(dataUser) {
        window.localStorage.setItem(encryptStringHash("userData"), encryptString(JSON.stringify(dataUser)))
    },

    getDatosUsuario: function() {
        let userData = window.localStorage.getItem(encryptStringHash("userData"))
        if (userData)
            return JSON.parse(decryptString(userData))
        else
            return null
    },

    removeDatosUsuario: function() {        
        try{
            window.localStorage.removeItem(encryptStringHash("userData"))
        }catch(error){
        }
    },

    getPermisosUsuario: function() {        
        try {
            let userData = window.localStorage.getItem(encryptStringHash("userData"))
            if (userData) {
                let user = JSON.parse(decryptString(userData))
                return user.permisos
            }else
                return []            
        } catch (error) {
            return []
        }
    },

    getNombreUsuario: function() {
        try {
            let userData = window.localStorage.getItem(encryptStringHash("userData"))
            if (userData) {
                let user = JSON.parse(decryptString(userData))
                return [user.nombre, user.apellidoPaterno, user.apellidoMaterno].join(' ')
            }
        } catch (error) {
            return []
        }
    },

    encryptString: function(valor) {
        let _valor = encryptString(valor)
        return _valor
    },

    decryptString: function(valor) {
        let _valor = decryptString(valor)
        return _valor
    }
} 